import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import LinearProgress from "@material-ui/core/LinearProgress";
import Button from "@material-ui/core/Button";
import SnackBar from "@material-ui/core/Snackbar";
import Grid from "@material-ui/core/Grid";
import MuiAlert from "@material-ui/lab/Alert";
import JwtDecode from "jwt-decode";
import Axios from "axios";
import { connect } from "react-redux";

import Header from "../../../Component/NavBar/User/Header/Header";
import Footer from "../../../Component/NavBar/User/Footer/Footer";
import { url } from "../../../config/config";
import { useStyles } from "./PublishBook.css";
import FormLoader from "../../../Component/FormLoader/FormLoader";

const CustomLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "#1a90ff",
  },
}))(LinearProgress);

class PublishBook extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        title: "",
        author: "",
        genre: "",
        price: "",
        pageCount: "",
        publishedDate: "",
        profileUrl: "",
        description: "",
        pdfFile: "",
        pdfFileUrl: "",
      },
      category: [],
      authorName: "",
      authorId: "",
      titleError: "",
      pageCountError: "",
      priceError: "",
      descriptionError: "",
      bookCoverError: "",
      pdfError: "",
      fileUrl: "",
      imagePercentage: 0,
      fileePercentage: 0,
      success: "",
      notificationOpen: false,
      isVerified: "",
      loading: false,
    };
  }

  componentDidMount() {
    if (this.props.editStatus) {
      this.getBookData(this.props.bookId);
    }
    this.getAuthorData();
  }

  getAuthorData = async () => {
    try {
      const decode = JwtDecode(this.props.authorToken);
      this.getCategoryData();
      this.setState({
        authorName:
          decode.firstName + " " + decode.middleName + " " + decode.lastName,
        isVerified: decode.isVerified,
        data: {
          ...this.state.data,
          author: decode._id,
        },
      });
    } catch (err) {}
  };

  getBookData = async (bookId) => {
    const response = await Axios.get(`${url}/api/books/${bookId}`);
    if (response.data.length !== 0) {
      this.setState({
        data: {
          title: response.data.title,
          genre: response.data.genre,
          price: response.data.price,
          author: response.data.author._id,
          pageCount: response.data.pageCount,
          description: response.data.description,
          profileUrl: response.data.bookCoverUrl,
          publishedDate: response.data.publishedDate,
          pdfFile: response.data.bookFileUrl,
        },
        authorName:
          response.data.author.firstName +
          " " +
          response.data.author.middleName +
          " " +
          response.data.author.lastName,
      });
      if (response.data.bookFileUrl) {
        const pdfResponse = await Axios.get(
          `${url}/api/file/image/${response.data.bookFileUrl}/${bookId}`,
          {
            headers: {
              "x-auth-token": this.props.authorToken,
            },
          }
        );
        console.log(pdfResponse);
        if (pdfResponse.data) {
          this.setState({
            data: {
              ...this.state.data,
              pdfFileUrl: pdfResponse.data,
            },
          });
        }
      }
    }
  };

  getCategoryData = async () => {
    const response = await Axios.get(`${url}/api/categories`);
    let newArray = response.data.filter((category) => category.name !== "All");
    this.setState({
      category: newArray,
    });
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleImageUpload = (e) => {
    let reader = new FileReader();
    let files = e.target.files[0];
    reader.onload = (e) => {
      this.setState({
        data: {
          ...this.state.data,
          profileUrl: e.target.result,
        },
      });
    };

    reader.onprogress = (data) => {
      if (data.lengthComputable) {
        let progress = parseInt((data.loaded / data.total) * 100, 10);
        this.setState({
          imagePercentage: progress,
        });
      }
    };

    if (files) {
      reader.readAsDataURL(files);
    }
  };

  handleImageProgress = () =>
    this.state.imagePercentage ? (
      <React.Fragment>
        <CustomLinearProgress
          value={this.state.imagePercentage}
          variant="determinate"
        />
        {this.state.imagePercentage === 100 ? (
          <React.Fragment>Upload Complete</React.Fragment>
        ) : (
          <React.Fragment>{this.state.imagePercentage}%</React.Fragment>
        )}
      </React.Fragment>
    ) : null;

  handleFileUpload = (e) => {
    let reader = new FileReader();
    this.setState({
      data: { ...this.state.data, pdfFile: e.target.files[0] },
    });
    let files = e.target.files[0];
    reader.onload = (e) => {
      this.setState({
        fileUrl: e.target.result,
      });
    };

    reader.onprogress = (data) => {
      if (data.lengthComputable) {
        var progress = parseInt((data.loaded / data.total) * 100, 10);
        this.setState({
          filePercentage: progress,
        });
      }
    };

    if (files) {
      reader.readAsDataURL(files);
    }
  };

  handleFileProgress = () =>
    this.state.filePercentage ? (
      <React.Fragment>
        <CustomLinearProgress
          value={this.state.filePercentage}
          variant="determinate"
        />
        {this.state.filePercentage === 100 ? (
          <React.Fragment>Upload Complete</React.Fragment>
        ) : (
          <React.Fragment>{this.state.filePercentage}%</React.Fragment>
        )}
      </React.Fragment>
    ) : null;

  checkError = (TitleError, PdfError) => {
    let titleError = TitleError;
    let pageCountError = "";
    let priceError = "";
    let descriptionError = "";
    let bookCoverError = "";
    let pdfError = PdfError;

    if (this.state.data.title.length < 5) {
      titleError = "Title must be minimum of length 5";
    }

    if (this.state.data.pageCount <= 0) {
      pageCountError = "Page count mustnot be lessthan 1";
    }

    if (this.state.data.price <= 0) {
      priceError = "Price mustnot be less than 1";
    }

    if (this.state.data.description.length < 3) {
      descriptionError = "description must be minimum of length 3";
    }

    if (!this.state.data.profileUrl) {
      bookCoverError = "Book Cover must be uploaded";
    }

    if (
      titleError ||
      pageCountError ||
      priceError ||
      descriptionError ||
      bookCoverError ||
      pdfError
    ) {
      this.setState({
        titleError,
        pageCountError,
        priceError,
        descriptionError,
        bookCoverError,
        pdfError,
      });
      return true;
    } else {
      this.setState({
        titleError: "",
        pageCountError: "",
        priceError: "",
        descriptionError: "",
        bookCoverError: "",
        pdfError: "",
      });
      return false;
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    let fileData = new FormData();
    fileData.append("bookCover", this.state.data.profileUrl);
    fileData.append("bookFile", this.state.data.pdfFile);
    fileData.append("title", this.state.data.title);
    fileData.append("authorId", this.state.data.author);
    fileData.append("genre", this.state.data.genre);
    fileData.append("publishedDate", this.state.data.publishedDate);
    fileData.append("pageCount", this.state.data.pageCount);
    fileData.append("price", this.state.data.price);
    fileData.append("description", this.state.data.description);
    if (errorStatus === false) {
      this.setState({ loading: true });
      if (this.props.editStatus) {
        const response = await Axios.put(
          `${url}/api/books/${this.props.match.params.bookId}`,
          fileData,
          {
            headers: {
              "x-auth-token": this.props.authorToken,
            },
          }
        );
        if (response.data.errorMessage || response.data.error) {
          if (response.data.errorMessage) {
            this.checkError(response.data.errorMessage, "");
            this.setState({ loading: false });
          } else {
            this.checkError("", response.data.error);
            this.setState({ loading: false });
          }
        } else {
          if (response.data.success && errorStatus === false) {
            this.handleNotificationOpen();
            this.setState({ success: response.data.success });
            this.props.history.push("/mybooks/Author");
          }
        }
      } else {
        const response = await Axios.post(`${url}/api/books`, fileData, {
          headers: {
            "x-auth-token": this.props.authorToken,
          },
        });
        if (response.data.errorMessage) {
          this.checkError(response.data.errorMessage, "");
          this.setState({ loading: false });
        } else if (response.data.error) {
          this.checkError("", response.data.error);
          this.setState({ loading: false });
        } else {
          if (response.data.success && errorStatus === false) {
            this.handleNotificationOpen();
            this.setState({ success: response.data.success });
            this.props.history.push("/mybooks/Author");
          }
        }
      }
    }
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  showNotification = (notificationStyle) => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        className={notificationStyle}
        autoHideDuration={2600}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="success"
          elevation={6}
          variant="filled"
        >
          Your book is send for approval.
        </MuiAlert>
      </SnackBar>
    );
  };

  compare = (a, b) => {
    const labelA = a.name.toUpperCase();
    const labelB = b.name.toUpperCase();

    let comparison = 0;
    if (labelA > labelB) {
      comparison = 1;
    } else if (labelA < labelB) {
      comparison = -1;
    }
    return comparison;
  };

  render() {
    const { classes } = this.props;
    this.state.category.sort(this.compare);
    return (
      <div>
        <Header />
        <div className={classes.root}>
          <div style={{ fontSize: 24 }}>Publish Book</div>
          <form onSubmit={this.handleSubmit}>
            <TextField
              name="title"
              type="string"
              label="Title"
              fullWidth
              required
              margin="normal"
              variant="outlined"
              style={{ outline: "none" }}
              placeholder="Enter title of book"
              error={this.state.titleError ? true : false}
              helperText={this.state.titleError}
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              className={classes.inputWithMargin}
              value={this.state.data.title}
              onChange={this.handleChange}
            />

            <TextField
              name="author"
              label="Author"
              type="text"
              fullWidth
              required
              disabled
              margin="normal"
              variant="outlined"
              style={{ outline: "none" }}
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              className={classes.inputWithoutMargin}
              value={this.state.authorName || ""}
            />

            <TextField
              name="genre"
              select
              label="Genre"
              fullWidth
              required
              margin="normal"
              variant="outlined"
              style={{ outline: "none" }}
              helperText="If the genre you want is not listed, request to add the genre you want"
              SelectProps={{
                native: true,
              }}
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              className={classes.inputWithMargin}
              value={this.state.data.genre}
              onChange={this.handleChange}
            >
              <option value="">Select Any One</option>
              {this.state.category.map((category, index) => (
                <option key={index} value={category.name}>
                  {category.name}
                </option>
              ))}
            </TextField>

            <TextField
              name="publishedDate"
              type="date"
              label="Published Date"
              required
              margin="normal"
              variant="outlined"
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              className={classes.inputWithoutMargin}
              value={this.state.data.publishedDate}
              onChange={this.handleChange}
            />

            <TextField
              name="pageCount"
              type="number"
              label="Total Page Number"
              required
              margin="normal"
              variant="outlined"
              placeholder="Enter total page number of the book"
              error={this.state.pageCountError ? true : false}
              helperText={this.state.pageCountError}
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              className={classes.inputWithMargin}
              value={this.state.data.pageCount}
              onChange={this.handleChange}
            />

            <TextField
              name="price"
              type="number"
              label="Price"
              required
              margin="normal"
              variant="outlined"
              placeholder="Assign Price for the book"
              error={this.state.priceError ? true : false}
              helperText={this.state.priceError}
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              className={classes.inputWithoutMargin}
              value={this.state.data.price}
              onChange={this.handleChange}
            />

            <TextField
              name="description"
              type="string"
              label="Description"
              required
              multiline
              fullWidth
              margin="normal"
              rows={4}
              rowsMax={8}
              variant="outlined"
              placeholder="write brief description about the book"
              style={{ outline: "none" }}
              error={this.state.descriptionError ? true : false}
              helperText={this.state.descriptionError}
              InputProps={{
                classes: {
                  focused: classes.focused,
                  notchedOutline: classes.notchedOutline,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              value={this.state.data.description}
              onChange={this.handleChange}
            />

            <Grid container spacing={3}>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                xl={6}
                lg={6}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              >
                {console.log(this.state.data.pdfFile)}
                {/* {this.state.data.pdfFile && (
                  <PDFReader url={this.state.data.pdfFile} width={200} />
                )} */}
                <label style={{ fontSize: 18 }}>Choose book file</label>
                <input
                  accept="application/pdf"
                  type="file"
                  onChange={this.handleFileUpload}
                />
                <div style={{ padding: 10 }}>{this.handleFileProgress()}</div>
                <div style={{ color: "red" }}>{this.state.pdfError}</div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                xl={6}
                lg={6}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              >
                {this.state.data.profileUrl && (
                  <img
                    src={this.state.data.profileUrl}
                    alt="Book Cover Page"
                    style={{ width: 200, height: 200 }}
                  />
                )}
                <label style={{ fontSize: 18 }}>
                  Choose Cover Image for book
                </label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={this.handleImageUpload}
                />
                <div style={{ padding: 10 }}>{this.handleImageProgress()}</div>
                <div style={{ color: "red" }}>{this.state.bookCoverError}</div>
              </Grid>
            </Grid>

            <div>
              {this.state.isVerified ? (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Button type="submit" className={classes.buttonStyle}>
                    {this.props.editStatus ? "Update" : "Submit"}
                  </Button>
                  {this.state.loading && <FormLoader />}
                </div>
              ) : (
                <div
                  style={{
                    fontSize: 24,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  You need to first verify your email address in order to
                  publish your book
                </div>
              )}
            </div>
            {this.showNotification(classes.notificationStyle)}
          </form>
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authorToken: state.AuthorReducer.authorToken,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(PublishBook));
